/**************************************************************************************************/
/*   File: /src/app/egov/egov.navbar.component.ts                                                 */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as fromShared from '../shared';
import * as fromStores from '../stores';

import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import {
    EgovAuthConfiguration,
    User
} from '@siag/js-egov-authentication';
import { Observable, Subscription, from } from 'rxjs';

import { EgovService } from './egov.service';
import { HeaderService } from '../shared/services';
import { NGXLogger } from 'ngx-logger';
import { Store } from '@ngrx/store';
import { environment } from '../../environments/environment.prod';
import { Loaded } from '../shared/models/loaded';

/**
 * The newplan frontend egov navbar
 */
@Component({
    selector: 'nwpl-frnt-egov-navbar',
    templateUrl: './egov.navbar.component.html',
    styleUrls: ['./egov.navbar.component.scss']
})
export class EgovNavbarComponent implements OnInit, OnDestroy {
    /**
     * The user
     */
    user$: Observable<User>;
    /**
     * Get the current language
     */
    currentLanguage$: Observable<fromShared.models.Language>;
    /**
     * The loaded event emitter
     */
    @Output() loaded: EventEmitter<Loaded> = new EventEmitter<Loaded>();
    /**
     * The array of subscription
     */
    private subscriptions: Subscription[] = [];
    /**
     * The user widget config
     */
    private userWidgetConfig: any;

    private loadedObject: Loaded = new Loaded;
    /**
     * The contructor
     * @param logger The logger
     * @param egovService the egov service
     */
    constructor(private store: Store<fromStores.states.fromRoot.RootState>,
        private logger: NGXLogger,
        private egovService: EgovService,
        private headerService: HeaderService,
        private changeDetector: ChangeDetectorRef) {
        this.egovService.setWidgetLanguage(environment.defaultLanguage);
        // tslint:disable-next-line
        this.currentLanguage$ = this.store.select(
            fromStores.selectors.fromUi.getCurrentLanguage
        );
    }

    /**
     * The ng on init
     */
    ngOnInit() {
        this.user$ = from(this.egovService.getCurrent());

        const subscriptionUser = this.user$.subscribe((user) => {
            if (
                user && 
                user.isAuthenticated === true &&
                (
                    user.username === '' || 
                    user.username === undefined || user.username === null
                )
            ) {
                user.username = (user.owner as any).fiscalCode;
                this.logger.info('The fiscal code is', user.username);
            }

            if (user && user.username) {
                this.store.dispatch(
                    new fromStores.actions.fromUi.SetLoggedUser(
                        {
                            user: new User(user)
                        }
                    )
                );
            } else {
                this.store.dispatch(
                    new fromStores.actions.fromUi.UnSetLoggedUser({
                        isoCode: environment.defaultLanguage
                    })
                );
            }
            this.userWidgetConfig = this.egovService.widgetConfig;
            this.loadedObject.loaded = true;
            this.loaded.emit(this.loadedObject);
        }, (error) => {
              this.loadedObject.errorMessage = 'Server returned: ' + error.status + ' - ' + error.error.message;
              this.loadedObject.loaded = false;
              this.loaded.emit(this.loadedObject);
            }
        );

        this.subscriptions.push(subscriptionUser);

        const subscriptionCurrentLanguage = this.currentLanguage$.subscribe((language) => {
            this.logger.trace('The language has been changed to', language.isoCode);
            this.egovService.setWidgetLanguage(language.isoCode);
            this.userWidgetConfig = this.egovService.widgetConfig;
        });
        this.subscriptions.push(subscriptionCurrentLanguage);

    }
    /**
     * The ng on destroy hook
     */
    /* istanbul ignore next */
    ngOnDestroy(): void {
        /* this.logger.trace('Remove subscriptions EgovComponent'); */
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

}